import { BarLinkOptions } from '../../../bar-link/bar-link-options.model';
import { BarMenuItemTag } from './bar-menu-item-tag.model';
import { Observable } from 'rxjs';

/**
 * @deprecated use BaasMenuItem in conjuction with &lt;baas-layout&gt;
 * Represents a menu item.
 */
export class BarMenuItemOptions extends BarLinkOptions {
    /** 
     * Whether this menu item is selected. 
     * Normally the current selection is defined automatically based on the url. 
     * This offers the possibity to manage the selection of the menu item yourself.*/
    selected?: boolean;
    /** Whether this menu item is expanded  */
    expanded?: boolean;
    /** The code of the application where the menu item belongs to */
    appCode?: string;
    /** The child menu items */
    children?: BarMenuItemOptions[];
    /** Tags added to the menu item to indicate extra information about a page e.g. count of remarks, required page,... */
    tags?: Observable<BarMenuItemTag[]> | Promise<BarMenuItemTag[]> | BarMenuItemTag[] | (() => BarMenuItemTag[]);
    /** match the provided path (routerLink/routerUrl/href): values are "full" or "prefix" */
    pathMatch?: string;
}
